"use client";
import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
// @ts-expect-error dynamic import
import styles from './../tailwind.css?inline';


  const ShadowDomWrapper: React.FC<{ children: React.ReactNode, useTailwindStyles?: boolean|undefined }> = ({ children, useTailwindStyles = true }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null);

  useEffect(() => {
    if (wrapperRef.current && !shadowRoot) {
      // Check if shadow DOM already exists on the element
      let root = wrapperRef.current.shadowRoot;
      
      if (!root) {
        // Only attach shadow DOM if it doesn't already exist
        root = wrapperRef.current.attachShadow({ mode: 'open' });
      }
      
      if (useTailwindStyles) {
        // Clear existing styles and add new ones
        const existingStyle = root.querySelector('style');
        if (existingStyle) {
          existingStyle.remove();
        }
        const styleElement = document.createElement('style');
        styleElement.textContent = styles;
        root.appendChild(styleElement);
      }
      setShadowRoot(root);
    }
  }, [shadowRoot, useTailwindStyles]);

  return (
    <div ref={wrapperRef}>
      {shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
    </div>
  );
};

export default ShadowDomWrapper;
